import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { FetchedNote } from "@/services/api/fetchers/notes";
import { EditorMobile } from "./components/Editor.mobile";
import { EditorDesktop } from "./components/Editor.desktop";
import { EditorData, ToolbarItemKey } from "../../types";
import "./index.css";

export interface EditorProps {
  initialData?: EditorData;
  isEditable?: boolean;
  note: FetchedNote | null;
  refetchedNote: Partial<FetchedNote> | null;
  onChange?: (data: EditorData) => void;
  toolbarKeys?: ToolbarItemKey[];
}

export function Editor(props: EditorProps) {
  const deviceType = useBoundStore(useShallow((state) => state.device.type));

  return deviceType === "mobile" ? <EditorMobile {...props} /> : <EditorDesktop {...props} />;
}
